import CustomModal from '@/components/ui/customModal'
import Input from '@/components/ui/input'
import { useTranslations } from 'next-intl'
import { useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { IoCloseOutline } from 'react-icons/io5'
import { Button } from 'rsuite'
import styles from './styles.module.scss'

type Props = {
  open: any
  close: () => void
  orderId: string | undefined
  onApplyVoucher: (code: string) => Promise<any>
  isLoading: boolean
  voucherError: string | null
  setVoucherError: (err: string | null) => void
  setVoucherCode: (code: string | null) => void
  voucherCode: string | null
}

type FormData = {
  promo: string
}

export default function Promocode({
  open,
  close,
  orderId,
  onApplyVoucher,
  isLoading,
  voucherError,
  setVoucherError,
  setVoucherCode,
  voucherCode,
}: Props) {
  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
    reset,
    setError,
    clearErrors,
    watch,
  } = useForm<FormData>({
    mode: 'onChange',
    defaultValues: {
      promo: voucherCode || '',
    },
  })

  const promoValue = watch('promo')

  const onSubmit = async (data: FormData) => {
    if (!orderId) {
      console.error('Order ID is missing in Promocode modal')
      return
    }
    clearErrors('promo')
    try {
      await onApplyVoucher(data.promo)
    } catch (error) {
      console.error('Error on apply voucher: ', error)
    }
  }

  useEffect(() => {
    if (open) {
      reset({ promo: voucherCode || '' })
      setVoucherError(null)
      clearErrors('promo')
    }
  }, [open, reset])

  useEffect(() => {
    if (voucherError) {
      setError('promo', {
        type: 'server',
        message: voucherError,
      })
    }
  }, [voucherError, setError])

  useEffect(() => {
    if (promoValue === '' && voucherError !== null) {
      setVoucherError(null)
      if (errors.promo) {
        clearErrors('promo')
      }
    }
  }, [promoValue, voucherError, setVoucherError, clearErrors, errors.promo])

  const handleReset = () => {
    reset({ promo: '' })
    setVoucherError(null)
    clearErrors('promo')
  }
  const t = useTranslations('Drawer.promocode-modal')

  return (
    <div className={styles.root}>
      <CustomModal
        closeOnOutsideClick
        open={open}
        close={close}
        className={styles.modalPromo}
      >
        <div className={styles.header}>
          <div className={styles.headerTitle}>{t('title')}</div>
          <IoCloseOutline onClick={close} className={styles.headerClose} />
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Controller
            name="promo"
            control={control}
            rules={{
              required: 'Промокод обязателен',
            }}
            render={({ field }) => (
              <Input
                modalInput
                state={field.value}
                setState={field.onChange}
                label={t('enter-code')}
                error={errors}
                name="promo"
                className={styles.input}
              >
                <span
                  className={`${styles.inputText} ${
                    voucherError ? styles.inputTextError : ''
                  }`}
                  onClick={() => {
                    if (!errors.promo) return
                    field.onChange('')
                  }}
                >
                  {voucherError ? (
                    <Button
                      className={`${styles.btn} ${styles.btnError}`}
                      type="button"
                      onClick={handleReset}
                    >
                      {t('reset')}
                    </Button>
                  ) : (
                    <Button
                      type="submit"
                      loading={isLoading}
                      disabled={isLoading}
                      className={styles.btn}
                    >
                      {t('apply')}
                    </Button>
                  )}
                </span>
              </Input>
            )}
          />
        </form>
        <div className={styles.footer}>
          <p className={styles.footerText}>{t('subtext')}</p>
        </div>
      </CustomModal>
    </div>
  )
}
